<ng-template
  [componentLoader]="selectedCustomComponent"
  [componentInputs]="this.data"
  [componentOutputs]="['resultData']"
  (output)="customComponentOutput($event)"
>
</ng-template>
